class videoHelper{
	constructor() {
		this.bindVideoModal();
		this.videoKill();
	}
	deferLoad(video) {
		if ( window.innerWidth < 992) {
			return;
		}

		// video.onloadstart = (e) => console.log('Video started loading', e);
		// video.oncanplay = (e) => {
		// 	console.log('Video can play', e, e.target);
		// 	canPlay = true;
		// 	e.target.play().then(() => {
		// 		console.log('Video play');
		// 	}, (err) => {
		// 		console.warn('Video play failed', err);
		// 	});
		// };
		// video.onplaying = (e) => console.log('Video is playing', e);
		// video.onerror = (err) => console.log('Video error', err);

		video.querySelectorAll('source').forEach((source) => {
			source.setAttribute('src', source.getAttribute('data-src'));
		});
		video.load();
	}
	bindVideoModal() {
		var buttons = $('[data-toggle="modal-video"]');
		buttons.each(function(i, el) {
			$(this).click(function(e) {
				e.preventDefault();
				var target = $(this).data('target'),
					videoSrcUrl = $(this).data('videoSrc');
				var iframe = $(target).find('iframe')[0];
				$(iframe).attr('src', videoSrcUrl);
				$(target).modal('show');
			});
		});
	}
	videoKill() {
		if ($('.modal--video')[0]) {
			$('.modal--video').each(function () {
				var modal = $(this),
					btn = $(this).find('button.close')[0],
					tar = $(this).find('.modal-body')[0];
				$(btn).data('dismiss', null);
				$(btn).click(function (e) {
					e.preventDefault();
					var html = $(tar).html();
					$(tar).html(html);
					modal.modal('hide');
				});
			});
		}
	}
}
window.app.add('video', new videoHelper());